<template>
    <button :disabled="loading || disabled" :type="type" class="app--button border--button">
        <span :class="loading ? 'invisible' : 'visible'">
            <AppIcon v-if="icon" :value="icon"></AppIcon>
            {{ label }}
        </span>
        <span v-show="loading" class="loading"><AppIcon value="spinner"></AppIcon></span>
    </button>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: ''
            },
            icon: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'button'
            }
        }
    }
</script>
